<template>
	<card>
		<div slot="header" class="row align-items-center">
			<div class="col-12 col-md-8">
				<h4>Revisioni motore {{engine.name}}</h4>
			</div>
			<div class="col-12 col-md-4 text-md-right">
	            <router-link :to="`/engines/${engine.id}/revisions/create`">
	              <base-button type="primary">
	                <i class="tim-icons icon-simple-add"></i>
	                Crea nuova
	              </base-button>
	            </router-link>
			</div>				
		</div>
		<div v-if="revisions && revisions.length">
			<div class="revisions-table-list">
				<div class="row no-gutters row-scoll-x">
					<div class="col col-revision col-revision-label">
						<div class="revision-field" v-if="account.user.is('backoffice')">
							Numero report amministrativo
						</div>
						<div class="revision-field">Allegati</div>
						<div class="revision-field">Operatore</div>
						<div class="revision-field">Data</div>
						<div class="revision-field">Ore Motore</div>
						<div class="revision-field">Ore Parziali</div>
						<div class="revision-field">Tipologia Revisione</div>
						<div class="revision-field" v-for="field in technicalDetailsFields" :key="field.label">
							<span>
								{{field.label}}
							</span>
						</div>
						<div class="revision-field">
							Report inviato a
						</div>
					</div>
					<div
						class="col col-revision text-right"
						v-for="revision in technicalRevisions"
						:key="revision.id">
						<div class="revision-field" v-if="account.user.is('backoffice')">
							<span v-if="revision.finalRevision">
								{{revision.finalRevision.number}}
							</span>
							<span v-else>
								---
							</span>
						</div>
						<div class="revision-field text-center">
							<div class="text-info font-weight-bold cur-p p-0 m-0" @click="openAttachmentModal(revision.id)">
								<i class="tim-icons icon-image-02"></i>	Apri la gallery
								<b v-if="revision.attachments">({{revision.attachments.length}})</b>
							</div>
						</div>
						<div class="revision-field">
							<span v-if="revision.authorImported">{{revision.authorImported}}</span>
							<span v-else>
								{{revision.author.name }} {{revision.author.surname }}
							</span>
						</div>
						<div class="revision-field">{{revision.revisionDate | moment('DD/MM/YYYY')}}</div>
						<div class="revision-field">{{revision.engineHour}}</div>
						<div class="revision-field">{{revision.serviceEngineHour}}</div>
						<div class="revision-field">
							{{revision.type.join(',')}}
						</div>
						<div class="revision-field"
							v-for="(field,$index) in technicalDetailsFields"
							:key="$index"
							>
							<span class="text-content">
								{{revision.techinicalDetails[$index]}}
							</span>
						</div>
						<div
							:class="{
								'bg-success': revision.technicalEmailSent
							}"
							class="revision-field">
							<div v-if="!revision.technicalEmailSent">
								Report non inviato
							</div>
							<span class="text-content" v-else>
								<template v-if ="revision.technicalEmailSentDetails">
									<span v-if="revision.technicalEmailSentDetails.length">
										{{revision.technicalEmailSentDetails[revision.technicalEmailSentDetails.length - 1].email}}
									</span>
									<span v-else>Inviato</span>
								</template>
							</span>
						</div>
						<div class="revision-field actions">
							<router-link class="btn btn-secondary" :to="`/engines/${$route.params.id}/revisions/${revision.id}`">
								Modifica revisione tecnica
							</router-link>
							<router-link
								class="btn btn-info"
								v-if="revision.finalRevision && account.user.is('backoffice')"
								:to="`/engines/${$route.params.id}/revisions/${revision.finalRevision._id}`">
								Modifica revisione amministrativa
							</router-link>
							<router-link
								class="btn btn-danger"
								v-if="account.user.is('backoffice') && !revision.finalRevision"
								:to="`/engines/${$route.params.id}/revisions/${revision.id}/create-final`">
								Completa revisione amministrativa
							</router-link>
						</div>

						<div
							target="_blank"
							class="row no-gutters revision-field actions cur-p"
							@click="printPdf(`/#/print/engines/${$route.params.id}/technical-revisions/${revision.id}`)">
							<div class="col-auto text-info mr-2 cur-p">
								<i v-if="!printLoading" class="tim-icons icon-notes"></i>
								<i v-else class="fas fa-spin fa-spinner"></i>
							</div>
							<div class="col text-info font-weight-bold text-left cur-p">
								Scarica report revisione tecnica
							</div>
						</div>

						<div
							target="_blank"
							class="row no-gutters revision-field actions cur-p"
							v-if="account.user.is('backoffice') && revision.finalRevision"
							@click="printPdf(`/#/print/engines/${$route.params.id}/final-revisions/${revision.finalRevision._id}`)">
							<div class="col-auto text-info mr-2 cur-p">
								<i v-if="!printLoading" class="tim-icons icon-paper cur-p"></i>
								<i v-else class="fas fa-spin fa-spinner"></i>
							</div>
							<div class="col text-info font-weight-bold text-left cur-p">
								Scarica report revisione amministrativa
							</div>
						</div>
						
						<div
							v-if="!revision.finalRevision && account.user.is('backoffice')"
							target="_blank"
							class="cur-p actions revision-field text-center d-block font-weight-bold text-danger"
							@click="deleteRevision(revision._id)">
							<i class="tim-icons icon-trash-simple"></i>
							Elimina Revisione
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<h5 class="text-muted text-center">Nessuna revisione per il seguente motore,
	        <router-link :to="`/engines/${engine.id}/revisions/create`">
				creane una ora!
			</router-link>
			</h5>
		</div>

		<iframe :src="printUrl" class="print-iframe" ref="printIframe" />
		<modal
			class="signature-modal"
			:show.sync="modalAttachment">
			<div class="row no-gutters">
				<div class="col-12 col-md-6" v-for="attachment in revisionAttachments.attachments" :key="attachment.id">
					<div class="photo-container">
						<div class="btn btn-danger" @click="deleteImage(revisionAttachments,attachment)">
							del
						</div>
						<a :href="`/api/revisions/${revisionAttachments.id}/revision-attachments/${attachment.id}`" target="_blank" class="pic-container">
							<img :src="`/api/revisions/${revisionAttachments.id}/revision-attachments/${attachment.id}?size=mini`" alt="">
						</a>

					</div>
				</div>
			</div>
		</modal>
	</card>
</template>
<style lang="scss" scoped>
	.cur-p{
		cursor :pointer !important;
	}
	.photo-container{
		position: relative;	
		> .btn{
			position: absolute;
			top: 10px;
			right: 10px;
			z-index: 90;
		}
		a{
			display:block;
			position: relative;
			z-index: 50;
		}
	}
</style>
<style lang="scss">
	$borderColor : rgba(0,0,0,0.2);
	.print-iframe{
		opacity: 0;
	}
	.row-scoll-x{
		overflow: auto;
	}
	.pic-container{
		height: 210px;
		display: flex;
		background: #eee;
		padding: 10px;
		margin: 10px;
		img{
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
			margin: auto;
		}
	}
	.revisions-table-list{
		margin: 0 -15px;
		border: 1px solid $borderColor;
		border-width: 1px 0 0 1px;
		overflow: auto;
		> .row{
			flex-wrap:nowrap
		}
	}
	.col-revision{
		max-width: 200px;
		min-width: 200px;
		@media(max-width: 768px){		
			max-width: 180px;
			min-width: 180px;
			&.col-revision-label{
				max-width: 160px;
				min-width: 160px;
			}
		}
		border: 1px solid $borderColor;
		border-width: 0 1px 0 0;
		.revision-field:not(.actions){
			text-overflow: ellipsis;
			white-space: nowrap;
			max-height: 37px;
			overflow: hidden;
			position:relative;
			&:hover{
				overflow: visible;

				.text-content{
					text-overflow: initial;
					white-space: initial;
					left: 0;
					right: 0;
					position: absolute;
					background: white;
					text-align: left;
					box-shadow: 0 0 black;
					padding: 10px;
					top: 0;
					box-shadow: 0 0 10px rgba(#1d8cf8,0.5);
					z-index: 9000000;
					min-height: 37px;
					border-radius: 5px;
				}
			}
		}
		&.col-revision-label{
			background: rgba(0,0,0,0.05) ;
			font-weight: 600;
			position: sticky;
			left: 0;
			z-index: 90;
			background: #efefef;
			box-shadow: 10px 0px 10px -5px rgba(0,0,0,0.1);
		}
	}
	.revision-field{
		padding: 10px;
		box-sizing: border-box;
		line-height: 1.2em;
		min-height: 37px;
		border-bottom: 1px solid $borderColor;
		>.btn-link{
			padding:0;
			margin:0;
    		line-height: .9em;
		}
		.btn{
			padding-left: 15px;
			padding-right: 15px;
			font-weight: 600
		}
		.col-auto .tim-icons,.fas{
			font-size: 28px;
		}
	}
</style>
<script>
	import { Modal } from 'src/components'
	import { mapState, mapActions } from 'vuex'
	export default {
		name: 'engine-revisions-list',
		props:{
			engine: Object,
			site: Object,
			revisions: Array
		},
		components: {
			Modal
		},
		computed: {
			technicalRevisions() {
				return this.revisions
				// return this.revisions
				// 	.reduce((acc,rev) => {
				// 		if ( rev.phase !== 'final' ){
				// 			const checkDetail = this.detailtedRevision.filter(checkRev => checkRev.id === rev.id)
				// 			const revision = checkDetail ? {
				// 				...rev,
				// 				detail: checkDetail[0],
				// 			} : rev
				// 			acc.push(revision)
				// 		}
				// 		return acc
				// 	},[])
			},
			...mapState({
				account: state => state.account,
			})
		},
		watch: {
			printUrl(newValue){
				console.log(newValue)
				if (newValue){
					this.printLoading = true;
					setTimeout(()=>{
						const w = (this.$refs.printIframe.contentWindow || this.$refs.printIframe.contentDocument.defaultView);
						// w.print();
						this.printUrl = null;
						this.printLoading = false;
					},5000);
				}
			},

		},
		methods: {
			...mapActions('revisions', {
				getRevision: 'get',
				deleteRevisionModule: 'delete',
				deleteAttachment: 'deleteAttachment',
			}),
			deleteImage(revision, image){
				this.deleteAttachment({
					revisionId : revision.id,
					id: image.id
				})				
			},
			printPdf(url) {
				this.printUrl = url;
			},
			async openAttachmentModal(id) {
				const detailRevision = await this.getRevision({
					engineId: this.$route.params.id,
					id
				});
				this.revisionAttachments = detailRevision;
				this.modalAttachment = true
			},
			deleteRevision(id){
				const engineId = this.$route.params.id
				this.deleteRevisionModule({
					engineId,
					id
				})
			}
		},
		mounted() {
			// faccio la get di tutte le reviisoni che ci sono, una volta che ce l'ho l'ha inserisco in quella corrispondenta
			// this.technicalRevisions.forEach(async revision => {
			// 	const detail = await this.getRevision({
			// 		engineId: this.$route.params.id,
			// 		id: revision.id
			// 	});
			// 	this.detailtedRevision.push(detail)
			// });
		},
		data() {
			return {
				detailtedRevision: [],
				revisionAttachments: [],
				modalAttachment: false,
				printUrl: null,
				printLoading: false,
				computedKey: 0,
				documentToPrint: '',
				technicalDetailsFields: {
					airFilter : {
						label: 'Filtro Aria'
					} ,
					oilFilter : {
						label: 'Filtro Olio'
					} ,
					sparkPlugs : {
						label: 'Candele'
					} ,
					tappetsRegolation : {
						label: 'Regolazione Punterie'
					} ,
					batteriesControl : {
						label: 'Controllo Batterie'
					} ,
					engineBackPressure : {
						label: 'Contro pressione motore mbar'
					} ,
					compressor : {
						label: 'Compressore'
					} ,
					alternator : {
						label: 'Alternatore'
					} ,
					oxygenCarburation : {
						label: 'Carburazione ossigeno %'
					} ,
					breakthroughControl : {
						label: 'Controllo Sfondamenti'
					} ,
					glycolFilterCleaning : {
						label: 'Pulizia Filtri Glicole'
					} ,
					blowByFilterCleaning : {
						label: 'Filtro Blow-By'
					} ,
					glycolEngine : {
						label: 'Glicole motore'
					},
					glycolIntercooler : {
						label: 'Glicole intercooler'
					},
					leftExhaustBackPressureAtmMBar : {
						label: 'Contro pressione scarico six atmosfera mbar'
					} ,
					rightExhaustBackPressureAtmMBar : {
						label: 'Contro pressione scarico dex atmosfera mbar'
					} ,
					leftExhaustBackPressureRecoverMBar : {
						label: 'Contro pressione scarico six recupero mbar'
					} ,
					rightExhaustBackPressureRecoverMBar : {
						label: 'Contro pressione scarico dex recupero mbar'
					} ,
					engineKw : {
						label: 'Kw motore'
					} ,
					oilConsumption : {
						label: 'Consumo olio lt'
					} ,
					ch4 : {
						label: 'Ch4%'
					} ,
					note : {
						label: 'Note aggiuntive'
					},
				}
			}
		},
	}
</script>